// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_9m-0";
export var orangeButton = "_9m-1";